import "Styles/templates/page.about.scss";

import AutoplayVideo from '../components/autoplay-video';

AutoplayVideo();